<template>
    <button
        @click="toggleAccordion"
        :ref="id"
        :class="[
            {
                'open': accordionOpen,
            },
            `
                block
                w-full
                py-4
                cursor-pointer
                border-0
                border-solid
                border-b-2
                border-primary
            `
        ]"
    >
        <h3
            class="
                flex
                items-center
                justify-between
                mb-0
                text-primary
                accordion-title
            "
        >
            <span v-html="title" />

            <ui-icon
                icon="chevron-down"
                class="text-sm"
            />
        </h3>
        <div
            class="accordion-inner mt-4"
        >
            <slot />
        </div>
    </button>
</template>

<script>
export default {
    name: 'UiAccordion',
    data() {
        return {
            accordionOpen: false,
        };
    },
    props: {
        title: {
            required: true,
            type: String,
        },
        subtitle: {
            required: false,
            type: String,
        },
        id: {
            required: false,
            type: Number,
        },
    },
    mounted() {
        this.eventHub.$on('toggleAccordion', () => {
            this.accordionOpen = false;
        });
    },
    methods: {
        toggleAccordion() {
            this.accordionOpen = !this.accordionOpen;
        },
    },
};
</script>

<style lang="scss" scoped>
    .accordion {
        &-inner {
            display: none;

            .open & {
                display: block;
            }
        }

        &-title {
            .icon {
                .open & {
                    transform: scale(-1);
                }
            }
        }
    }
</style>
